/* &Co - sous-menus du tiroir en flyout a droite, ouverts au survol (souris, desktop) */
(function () {
  function injectStyle() {
    if (document.getElementById('andco-menu-flyout-style')) return;
    var css = [
      '@media screen and (min-width: 990px) and (hover: hover) and (pointer: fine){',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer{width:26rem;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer:has(.menu-drawer__menu>li>details[open]){width:52rem;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer__navigation{width:26rem;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer__menu>li>details>.menu-drawer__submenu{left:26rem;width:26rem;border-left:.1rem solid rgba(var(--color-foreground),.08);transform:translateX(0);visibility:hidden;opacity:0;transition:opacity .16s ease, visibility .16s ease;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer__menu>li>details[open]>.menu-drawer__submenu{visibility:visible;opacity:1;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer__submenu .menu-drawer__close-button{display:none;}',
      'header-drawer[data-breakpoint="desktop"] .menu-drawer__inner-submenu{padding-top:3rem;}',
      '}'
    ].join('');
    var st = document.createElement('style');
    st.id = 'andco-menu-flyout-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function init() {
    injectStyle();
    var drawers = document.querySelectorAll('header-drawer[data-breakpoint="desktop"]');
    if (!drawers.length) return;
    var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    drawers.forEach(function (drawer) {
      var tops = drawer.querySelectorAll('nav.menu-drawer__navigation > ul.menu-drawer__menu > li > details');
      tops.forEach(function (det) {
        var t;
        function open() {
          clearTimeout(t);
          tops.forEach(function (o) { if (o !== det) { o.classList.remove('menu-opening'); o.removeAttribute('open'); } });
          det.setAttribute('open', '');
          requestAnimationFrame(function () { det.classList.add('menu-opening'); });
        }
        function scheduleClose() {
          clearTimeout(t);
          t = setTimeout(function () {
            if (det.matches(':hover')) return;
            det.classList.remove('menu-opening');
            setTimeout(function () { if (!det.matches(':hover')) det.removeAttribute('open'); }, 260);
          }, 260);
        }
        det.addEventListener('mouseenter', function () { if (mq.matches) open(); });
        det.addEventListener('mouseleave', function () { if (mq.matches) scheduleClose(); });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
